module.exports = __webpack_public_path__ + "286337efaf2bfcf5c5e2aa9d63a15cff.png";